import React from 'react';
import Breadcrumbs from '@/components/Breadcrumbs';
import Footer from '@/components/Footer';
import ShopifyBuyButton from '@/components/ShopifyBuyButton';

const ShakerPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-4">
        <Breadcrumbs />
      </div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 items-start">
          <div className="space-y-6">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-foreground font-orbit">
              100% Tett Plast Shaker
            </h1>

            <div className="flex items-baseline gap-3">
              <span className="text-4xl font-bold text-primary">39 kr</span>
              <span className="text-lg text-muted-foreground">inkl. mva</span>
            </div>

            <p className="text-base sm:text-lg text-muted-foreground leading-relaxed">
              Opplev den ultimate shakeren som aldri lekker! Vår 600ml BPA-fri shaker er designet med presisjon for å gi deg en helt lekkasjesikker opplevelse, hver gang.
            </p>

            <div className="bg-muted p-4 sm:p-6 rounded-lg border border-border">
              <h3 className="text-lg sm:text-xl font-semibold text-foreground mb-4">Nøkkelegenskaper:</h3>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start gap-3">
                  <span className="text-primary">✓</span>
                  <span><strong className="text-foreground">100% lekkasjesikker</strong> - Garantert tett lokk</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-primary">✓</span>
                  <span><strong className="text-foreground">600ml kapasitet</strong> - Perfekt størrelse for alle behov</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-primary">✓</span>
                  <span><strong className="text-foreground">BPA-fri materiale</strong> - Trygg for daglig bruk</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-primary">✓</span>
                  <span><strong className="text-foreground">Ergonomisk design</strong> - Komfortabelt grep</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-primary">✓</span>
                  <span><strong className="text-foreground">Lett å rengjøre</strong> - Bred åpning for enkel vask</span>
                </li>
              </ul>
            </div>

            <div className="bg-muted p-4 sm:p-6 rounded-lg border border-border">
              <div className="flex items-start gap-4">
                <div className="text-2xl">🏆</div>
                <div>
                  <h3 className="text-lg sm:text-xl font-semibold text-foreground mb-2">Sammenlign og se forskjellen</h3>
                  <p className="text-muted-foreground">
                    Vi oppfordrer deg til å sammenligne våre produkter med andre aktører når det gjelder kvalitet, pris og innhold - for vi er faktisk best! Test gjerne forskjellen selv og opplev hvorfor våre kunder velger oss gang på gang.
                  </p>
                </div>
              </div>
            </div>

            <div className="pt-4">
              <ShopifyBuyButton
                productId="9358248444135"
                componentId="product-component-shaker"
                domain="6pjebd-jw.myshopify.com"
                storefrontAccessToken="24c563b5bb4fa1b2d3b84fcb8e32090c"
                className="w-full"
              />
            </div>
          </div>

          <div className="relative mt-6 lg:mt-0">
            <div className="lg:sticky lg:top-8">
              <img
                src="/lovable-uploads/7df6c9d3-dae1-4c10-b933-4f370133ca21.png"
                alt="Peveo's 100% Tett Plast Shaker"
                className="w-full h-auto max-h-[800px] object-contain rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ShakerPage;
